import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import clinicService from "../../../../../services/clinic.service";
import clinicbookingService from "../../../../../services/clinicbooking.service";


function AddEditDoctorInfo({ doctor,updateDoc,toogleEdit }) {
  const [clinicDoctors, setClinicDoctors] = useState([]); //used for userId
  const { clinicId } = useParams();
  const { register, handleSubmit, setValue, formState:{errors} } = useForm(
    {
        defaultValues: doctor.id? doctor : ""
    }
);

  useEffect(() => {
    //get list of clinic Doctors for Drop Down
    getClinicDoctors();
  }, []);

  const getClinicDoctors = () => {
    clinicService
      .getUsers(clinicId)
      .then((res) => {
        setClinicDoctors(res.data);
        //console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSubmit = (data)=>{
      
        let updateData = {...data}
        delete updateData.createdAt 
        delete updateData.modifiedAt 
        delete updateData.apptTypes
        //update doctor
        clinicbookingService.addUpdateDoctor(clinicId,updateData)
        .then(res=>{
          
            toast.success("Updated Doctor",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
        .catch(err=>{
            console.log(err)
        })
  }

  return <>
    <div className="card mt-3 p-4">
        <div className="card-body">

      
        <form onSubmit={handleSubmit(onSubmit)}>
           <div className="row mb-3">
               <div className="col-5">
                <label htmlFor="userId" className="form-label">Doctor  </label>
                <select className='form-select form-select-sm me-2' {...register("userId")}>
                    {clinicDoctors && clinicDoctors.map((doc)=>(
                        <option key={doc.id} value={doc.id}>{doc.firstName} {doc.lastName}</option>
                    ))}
                </select>
             </div>
           </div>
            <div className="row mb-3">
            <div className="col-5">
                <label htmlFor="displayname" className="form-label">Display Name</label>
                <input type="text" className="form-control" {...register("name")} />
             </div>
            </div>
            <div className="row mb-3">
                <div className="col-5">
                    <label htmlFor="photourl">Photo Url:</label>
                    <input type="text"  className="form-control" {...register("photo_url")} />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-5">
                    <label htmlFor="isActive">Status</label>
                <select className='form-select form-select-sm me-2' {...register("isActive")}>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                </select>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-5">
                    <label htmlFor="bio">Bio</label>
                    <textarea type="text" className="form-control" {...register("bio")}></textarea>
                </div>
            </div>
            <button className="btn btn-sm btn-success me-3" type="submit"><i className="bi bi-floppy"></i> Save</button>
            <button className="btn btn-sm btn-secondary" onClick={toogleEdit}><i className="bi bi-x-square"></i> Cancel</button>
        </form>
        </div>
    </div>
  </>;
}

export default AddEditDoctorInfo;
